/** 根据《生成式人工智能服务管理暂行办法》，AI 生图暂仅对白名单账号开放。 */
export const ISK_AI_GENERATION_RESTRICTED_NOTICE =
  '根据《生成式人工智能服务管理暂行办法》生图功能暂时受限';

/** 暂时放行 AI 生图（原始草图 / 手绘修图）的手机号 */
export const ISK_AI_GENERATION_ALLOWED_PHONES = ['18701399857'] as const;

export function normalizePhoneForIskGate(phone?: string | null): string {
  return String(phone || '').trim().replace(/^\+86/, '').replace(/\D/g, '');
}

export function canUseIskAiGeneration(phone?: string | null): boolean {
  const normalized = normalizePhoneForIskGate(phone);
  return Boolean(normalized)
    && (ISK_AI_GENERATION_ALLOWED_PHONES as readonly string[]).includes(normalized);
}
